import { IdToken } from '@auth0/auth0-spa-js';

export interface AuthToken extends IdToken {
  'https://quantummaps.com/app_metadata': {
    ui_rights: string[],
    tri_tenant: string,
    tenant_id: number,
    write_rights: string[],
    read_rights: string[],
    tenant_key: string,
  };
}

export function getClientID(): string {
  if (window.location.href.includes('localhost') || window.location.href.includes('mipro')) {
    return '9xUu3oS8Uzryg82VpLx0uGQjyJBP1KrK';
  } else {
    return 'yP1pcSrvE1H8KrIl9HwMideV8r79QOCp';
  }
}

export function getDomain(): string {
  if (window.location.href.includes('localhost') || window.location.href.includes('mipro')) {
    return 'mic.eu.auth0.com';
  } else {
    return 'quantummaps.eu.auth0.com';
  }
}
